import React from "react";

/**
 * AI assist pill button. Disabled in Phase 6 — wired up in Phase 7.
 * type: "draft" | "suggest"
 */
export default function AiPill({ type = "draft", onClick }) {
  const label = type === "draft" ? "✦ AI draft" : "✦ AI suggest";
  const isPhase7 = false; // flip to true in Phase 7

  return (
    <button
      style={{ ...styles.pill, ...(isPhase7 ? {} : styles.disabled) }}
      onClick={isPhase7 ? onClick : undefined}
      title={isPhase7 ? undefined : "Available in Phase 7"}
      disabled={!isPhase7}
    >
      {label}
    </button>
  );
}

const styles = {
  pill: {
    fontSize: "var(--text-xs)",
    fontWeight: "var(--weight-medium)",
    color: "var(--color-accent)",
    background: "var(--color-accent-subtle)",
    border: "1px solid transparent",
    borderRadius: "var(--radius-full)",
    padding: "3px var(--space-3)",
    cursor: "pointer",
    transition: "opacity var(--transition-fast)",
  },
  disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
};
